import React from "react";
import { Container } from "react-bootstrap";

const OurCoreValue = () => {
  return (
    <div className="py-5 my-lg-5 my-md-3 my-sm-2">
      <Container>
        <div className="d-flex flex-column justify-content-center align-items-center text-center">
          <h2 className="ff_Jakarta fs_48 fw-bolder common_clr_blue lh_151">
            Why Public Speaking Matters in Education
          </h2>
          <p className="ff_Poppins fw-normal fs_18 text_clr_grey lh_132 para_why_us">
            Research shows that early exposure to public speaking boosts
            academic performance, develops critical thinking, enhances emotional
            intelligence, builds resilience, prepares students for higher
            education and careers, and improves social skills and peer
            relationships.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default OurCoreValue;
